import { render } from "./import-orders.vue?vue&type=template&id=74d09c2e"
import script from "./import-orders.vue?vue&type=script&setup=true&lang=js"
export * from "./import-orders.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/modules/integrations/pages/link-marketplace/components/common/import-orders.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "74d09c2e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('74d09c2e', __exports__)) {
    console.log('reload')
    api.reload('74d09c2e', __exports__)
  }
  
  module.hot.accept("./import-orders.vue?vue&type=template&id=74d09c2e", () => {
    console.log('re-render')
    api.rerender('74d09c2e', render)
  })

}


export default __exports__